import React from 'react';
import { FieldSet, SidePanel, Thumbnail } from '@wix/design-system';
import { useTranslation } from '@wix/yoshi-flow-editor';
import { useStyles } from '@wix/tpa-settings/react';
import layoutParams from '../../../layoutParams';
import { dataHooks } from '../../../../../constants';
import { SocialFirstPresetIllustration } from '../../../../../assets/icons/SocialFirstPresetIllustration';
import { SocialLastPresetIllustration } from '../../../../../assets/icons/SocialLastPresetIllustration';
import { SocialButtonsPlacement } from '../../../../../constants/layoutConstants';
import { useStudio2WdsThumbnailSkin } from '../../../../common/AuthThumbnail/useStudio2WdsThumbnailSkin';

const THUMBNAIL_SIZE = 114;

export { SocialButtonsPlacement };

export const SocialPreset: React.FC = () => {
  const { t } = useTranslation();
  const styles = useStyles();
  const thumbnailSkin = useStudio2WdsThumbnailSkin();

  const socialButtonsFirst =
    styles.get(layoutParams.socialButtonsFirst) || SocialButtonsPlacement.FIRST;

  const onSocialPresetChange = (preset: SocialButtonsPlacement) => {
    styles.set(layoutParams.socialButtonsFirst, preset);
  };

  return (
    <SidePanel.Field divider={false}>
      <FieldSet
        legend={t(
          'memberAuthentication.loginForm.settingsPanel.layout.layoutPreset.title',
        )}
        direction="horizontal"
        columns="auto auto"
      >
        <Thumbnail
          dataHook={dataHooks.layoutTab.socialFirstThumbnail}
          size="tiny"
          selected={socialButtonsFirst === SocialButtonsPlacement.FIRST}
          onClick={() => onSocialPresetChange(SocialButtonsPlacement.FIRST)}
          hideSelectedIcon
          height={THUMBNAIL_SIZE}
          width={THUMBNAIL_SIZE}
          noPadding
          image={<SocialFirstPresetIllustration />}
          title={t(
            'memberAuthentication.loginForm.settingsPanel.layout.layoutPreset.socialFirst',
          )}
          textPosition="outside"
          skin={thumbnailSkin}
        />
        <Thumbnail
          dataHook={dataHooks.layoutTab.socialLastThumbnail}
          size="tiny"
          selected={socialButtonsFirst === SocialButtonsPlacement.LAST}
          onClick={() => onSocialPresetChange(SocialButtonsPlacement.LAST)}
          hideSelectedIcon
          height={THUMBNAIL_SIZE}
          width={THUMBNAIL_SIZE}
          noPadding
          image={<SocialLastPresetIllustration />}
          title={t(
            'memberAuthentication.loginForm.settingsPanel.layout.layoutPreset.socialLast',
          )}
          textPosition="outside"
          skin={thumbnailSkin}
        />
      </FieldSet>
    </SidePanel.Field>
  );
};
